import getConfig from 'next/config';
import { useEffect } from 'react';

export default function useBaseConfig() {
  useEffect(() => {
    const { publicRuntimeConfig } = getConfig();
    if (typeof window !== 'undefined') {
      (window as any).BASE_CONFIG = {
        ...(window as any).BASE_CONFIG,
        ...publicRuntimeConfig,
      };
    }
  }, []);
}
